"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var inputUtils_1 = require("../../core/inputUtils");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'skin', 'styleProperties'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, skin = _a.skin;
    return ({
        skin: skin === 'ResponsiveTextAreaDefaultSkin'
            ? 'ResponsiveTextAreaDefaultSkin'
            : 'TextAreaDefaultSkin',
        value: compData.value || '',
        label: compData.label,
        placeholder: compData.placeholder || compProps.placeholder,
        readOnly: compProps.readOnly || false,
        required: compProps.required || false,
        isDisabled: compProps.isDisabled || false,
        maxLength: compData.maxLength,
    });
});
var getTextPaddingCssVar = function (textAlignment, textPadding, hasResponsiveLayout) {
    var top = hasResponsiveLayout ? '0.75em' : '3px';
    var padding = textPadding === undefined ? 3 : textPadding;
    switch (textAlignment) {
        case 'left':
            return top + " 10px 3px " + padding + "px";
        case 'right':
            return top + " " + padding + "px 3px 10px";
        case 'center':
            return top + " " + padding + "px 3px " + padding + "px";
        default:
            return top + " 3px 3px 3px";
    }
};
exports.css = withCompInfo_1.withCompInfo([
    'compLayout',
    'compProps',
    'styleProperties',
    'isMobileView',
    'hasResponsiveLayout',
], function (_a, cssVars) {
    var compLayout = _a.compLayout, compProps = _a.compProps, styleProperties = _a.styleProperties, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout;
    var textAlignment = compProps.textAlignment, textPadding = compProps.textPadding, labelMargin = compProps.labelMargin;
    var sharedProps = __assign(__assign({}, cssVars), { '--dir': (textAlignment === 'right' ? 'rtl' : 'ltr'), '--textAlign': textAlignment, '--textPadding': getTextPaddingCssVar(textAlignment, textPadding, hasResponsiveLayout) });
    if (hasResponsiveLayout) {
        return sharedProps;
    }
    else {
        return __assign(__assign({}, sharedProps), { height: 'auto', '--labelMarginBottom': labelMargin + "px", '--inputHeight': inputUtils_1.getInputHeightInPx({
                compProps: compProps,
                compLayout: compLayout,
                isMobileView: isMobileView,
            }), '--labelPadding': inputUtils_1.getLabelPadding(compProps), '--requiredIndicationDisplay': inputUtils_1.getRequiredIndicationDisplay(styleProperties) });
    }
});
//# sourceMappingURL=TextAreaInput.js.map